import {useState} from "react";

import {Card} from "@/components/card/Card.tsx";
import {NavTabs} from "@/components/navTabs/NavTabs.tsx";
import {
  SLAReport,
  SLAReportResponseTime,
  SLAReportService,
  SLAReportViewGroup,
  UptimeTotals,
} from "@/lib/queries/reports.ts";
import {SLAReportOverviewResponseTime} from "@/pages/reports/sla/details/responsetime/SLAReportOverviewResponseTime.tsx";
import {SLAReportUptimeSection} from "@/pages/reports/sla/details/uptime/SLAReportUptimeSection.tsx";

enum SLAReportTab {
  Uptime = "uptime",
  ResponseTime = "response_time",
}

interface SLAReportOverviewProps {
  totals: UptimeTotals;
  items: SLAReportService[];
  report: SLAReport;
  groups: SLAReportViewGroup[];
  responseTime: SLAReportResponseTime[];
  dailyResponseData: boolean;
  groupOnly: boolean;
}

export const SLAReportOverview = ({
  totals,
  items,
  report,
  responseTime,
  groups,
  dailyResponseData,
  groupOnly,
}: SLAReportOverviewProps) => {
  const [tab, setTab] = useState<SLAReportTab>(SLAReportTab.Uptime);

  const multiTabs = report.show_uptime_section && report.show_response_time_section;

  return (
    <Card variant="white">
      {!multiTabs && <SLAReportUptimeSection totals={totals} report={report} items={items} groups={groups} />}
      {multiTabs && (
        <div>
          <NavTabs
            className="mb-4"
            items={[
              {
                title: "Uptime",
                id: SLAReportTab.Uptime,
              },
              {
                title: "Response Time",
                id: SLAReportTab.ResponseTime,
              },
            ]}
            selectedId={tab}
            selectTab={(t) => setTab(t as SLAReportTab)}
          />
          {tab === SLAReportTab.Uptime && (
            <SLAReportUptimeSection totals={totals} report={report} items={items} groups={groups} />
          )}
          {tab === SLAReportTab.ResponseTime && (
            <SLAReportOverviewResponseTime
              report={report}
              dailyResponseData={dailyResponseData}
              responseTime={responseTime}
              groupOnly={groupOnly}
            />
          )}
        </div>
      )}
    </Card>
  );
};
